module.exports = __webpack_public_path__ + "img/lens-150-minus-03.23a20ff4.png";